import React from 'react';
import { createPortal } from 'react-dom';
import { Col, Container, Row, Button, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import ChemTable from '../ChemTable';
import EditTable from '../EditTable';
import Tabs from '../Tabs';
import { Link } from 'react-router-dom';
import { withJobDefaultRoute } from './withJobDefaultRoute';
import { LockFill, UnlockFill, Search, HourglassSplit, EnvelopeAt } from 'react-bootstrap-icons';
import PartsModal from './PartsModal';
import EmailModal from './EmailModal';
import { encode } from 'html-entities';

class Job extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			job: {
				shop_job: {
					JOB_ID: ''
				},
				shop_job_pi: {},
				shop_job_rch: [],
				rch_history: [],
				shop_estimate: {},
				shop_job_labor: [],
				shop_job_material: [],
				job_scope: {
					JOB_SCOPE: '',
					JOB_NOTES: '',
					COMMENTS: ''
				},
				job_doc: [],
				job_comment: [],
				summary: {},
				summary_rch: [],
				summary_lines: [],
				total_mat: [],
				grand_mat: {},
				total_lab: [],
				grand_lab: {}
			},
			mrCartId: null,
			piColumns: this.copyColumns(piColumns),
			speedtypeEditColumns: this.copyColumns(speedtypeEditColumns),
			custColumns: this.copyColumns(custColumns),
			laborEditColumns: this.copyLaborEditColumns(),
			materialEditColumns: this.copyColumns(materialEditColumns),
			activeTab: props.params.activeTab || 'Description',
			editorsOpen: [],
			editable: props.editable,
			showPartSearch: false,
			partSearchProps: null,
			showEmail: false,
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadJob(this.props.params.activeTab || 'Description');
	}

	componentDidUpdate(prevProps) {
		var newActiveTab = this.props.params.activeTab || 'Description';
		
		// if this is a different job, reload the job
		if (this.props.params.jobId !== prevProps.params.jobId) {
			this.loadJob(newActiveTab);
		} else {
			var newState = this.copyObject(this.state);
			var newRenderKey = this.state.renderKey + 1;
						
			// this is necessary so browser back/forward buttons will work across tabs
			if (newActiveTab !== this.state.activeTab) {
				newState.activeTab = newActiveTab;
				newState.renderKey = newRenderKey;
			}
			
			// if anyone actually updated the state
			if (newState.renderKey > this.state.renderKey) {
				// set the new state
				this.setState(newState);
			}
		}
	}

	loadJob(activeTab) {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/GetJob',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				jobid: this.props.params.jobId
			}
		}).done(function (data) {			
			if (data.Success) {
				var i;
				// prepare job data
				var job = data.Data;
				self.mvc2js(job, piColumns);
				self.mvc2js(job, custColumns);
				
				// prepare pi columns
				var newPIColumns = self.copyColumns(piColumns);
				var piIdx = self.findColumnByAccessor(newPIColumns, 'shop_job_pi.OTHER_PI');
				if (!self.isEmpty(job.shop_job_pi.PI_ROLE)) {
					newPIColumns[piIdx].options.search.Children.push(
						{ Attribute: 'ROLE_ID', Operator: '=', LongValue: job.shop_job_pi.PI_ROLE });
				}
				
				// prepare speedtype columns
				var newSpeedtypeEditColumns = self.copyColumns(speedtypeEditColumns);
				if (!self.isEmpty(job.shop_job_pi.PI_ROLE)) {
					var speedtypeColIdx = self.findColumnByAccessor(newSpeedtypeEditColumns, 'SPEEDTYPE');
					newSpeedtypeEditColumns[speedtypeColIdx].options.search =
						{ Attribute: 'ROLE_ID', Operator: 'in', LongList: [0,job.shop_job_pi.PI_ROLE] };
				}
				
				// prepare cust columns
				var newCustColumns = self.copyColumns(custColumns);
				var custIdx = self.findColumnByAccessor(newCustColumns, 'shop_job_pi.CUSTOMER_ID');
				var shopIdx = self.findColumnByAccessor(newCustColumns, 'shop_job.SHOP_ID');
				if (!self.isEmpty(job.shop_job_pi.CUSTOMER_ID)) {
					newCustColumns[custIdx].options.search.Children.push(
					{ Attribute: 'ROLE_ID', Operator: '=', LongValue: job.shop_job_pi.CUSTOMER_ID });
				}
				if (self.isEmpty(job.shop_job.SHOP_ID) && !self.isEmpty(job.shop_job.SHOP_REQUESTED)) {
					newCustColumns[shopIdx].subscript = '(requested: ' + job.shop_job.SHOP_REQUESTED + ')';
				}
				
				// discover if any line items have been transferred or billed
				var lineItemsTransOrBilled = false;
				for (i = 0; i < job.shop_job_labor.length; i++) {
					if (!self.isEmpty(job.shop_job_labor[i].BILL_STATUS) &&
						(job.shop_job_labor[i].BILL_STATUS === 'Transferred' ||
						job.shop_job_labor[i].BILL_STATUS.startsWith('Billed'))) {
						lineItemsTransOrBilled = true;
						break;
					}
				}
				for (i = 0; i < job.shop_job_material.length; i++) {
					if (!self.isEmpty(job.shop_job_material[i].BILL_STATUS) &&
						(job.shop_job_material[i].BILL_STATUS === 'Transferred' ||
						job.shop_job_material[i].BILL_STATUS.startsWith('Billed'))) {
						lineItemsTransOrBilled = true;
						break;
					}
				}
				
				// if any line items have been transferred or billed
				if (lineItemsTransOrBilled) {
					// find shop ID column
					shopIdx = self.findColumnByAccessor(newCustColumns, 'shop_job.SHOP_ID');
					// make column non-editable as changing it would screw up the speedtypes on the transferred lines
					newCustColumns[shopIdx].editable = false;
				}
				
				// do math for Estimate tab
				self.calculateEstimates(job);
				
				// compose change info
				job.shop_job.CREATED = self.composeChangeInfo(job.shop_job.CREATED_BY, job.shop_job.DATE_CREATED);
				job.shop_job.MODIFIED = self.composeChangeInfo(job.shop_job.MODIF_BY, job.shop_job.DATE_MODIF);				
				
				// copy state
				var newState = self.copyObject(self.state);

				// add new data we just loaded
				newState.job = job;
				newState.activeTab = activeTab;
				newState.piColumns = newPIColumns;
				newState.custColumns = newCustColumns;
				newState.speedtypeEditColumns = newSpeedtypeEditColumns;
				newState.laborEditColumns = self.copyLaborEditColumns();
				
				// update render key, in case shopping cart didn't
				newState.renderKey = self.state.renderKey + 1;
				
				// set state
				self.setState(newState);
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	calculateEstimates(job) {
		// calculate costperh as a proportional average of each speedtype's costperh
		var costperh = 0;
		var discount = 0;
		var totalpct = 0;
		var discount_totalpct = 0;
		var est_labor_amount = 0;
		var discount_type = null;

		for (var i = 0; i < job.shop_job_rch.length; i++) {
			// add proportion of cost per hour
			costperh += this.getNumeric(job.shop_job_rch[i].COSTPERH, 0) * 
				this.getNumeric(job.shop_job_rch[i].PERCENT, 0);
			
			// add proportion of discount
			if (job.shop_job_rch[i].DISCOUNT_TYPE === 'Disc.') {
				if (this.getNumeric(job.shop_estimate.ESTIMATED_LABOR, 0) !== 0 &&
					this.isNumeric(job.shop_job_rch[i].COSTPERH)) {
					if (job.shop_job_rch[i].SPONSORED_FLAG === 'Y') {
						discount += (1 - this.getNumeric(job.shop_estimate.ALT_DISCOUNT, 0)) *
							this.getNumeric(job.shop_job_rch[i].PERCENT, 0);
					} else {
						discount += (1 - this.getNumeric(job.shop_estimate.DISCOUNT, 0)) *
							this.getNumeric(job.shop_job_rch[i].PERCENT, 0);
					}
					discount_totalpct += this.getNumeric(job.shop_job_rch[i].PERCENT, 0);
					est_labor_amount += job.shop_estimate.ESTIMATED_LABOR *
						job.shop_job_rch[i].COSTPERH * discount;					
				}
				discount_type = job.shop_job_rch[i].DISCOUNT_TYPE;
			} else if (job.shop_job_rch[i].DISCOUNT_TYPE === 'No Discount') {
				if (this.getNumeric(job.shop_estimate.ESTIMATED_LABOR, 0) !== 0 &&
					this.isNumeric(job.shop_job_rch[i].COSTPERH)) {
					est_labor_amount += job.shop_estimate.ESTIMATED_LABOR *
						job.shop_job_rch[i].COSTPERH *
						this.getNumeric(job.shop_job_rch[i].PERCENT, 0);
				}
				if (discount_type !== 'Disc.') discount_type = job.shop_job_rch[i].DISCOUNT_TYPE;
			} else if (!['Disc.','No Discount'].includes(discount_type)) {
				discount_type = job.shop_job_rch[i].DISCOUNT_TYPE;
			}

			totalpct += job.shop_job_rch[i].PERCENT;
		}
		job.shop_estimate.COSTPERH = totalpct === 0 ? 0 : (costperh/totalpct);
		job.shop_estimate.DISCOUNT = discount_totalpct === 0 ? 1 : (discount/discount_totalpct);
		job.shop_estimate.PI_EST_LABOR = '$' + (totalpct === 0 ? 0 : (est_labor_amount/totalpct)) + 
			' (' + this.getNumeric(job.shop_estimate.ESTIMATED_LABOR, 0) + '*' + job.shop_estimate.COSTPERH + (job.shop_estimate.DISCOUNT === 1 ? '' : ('*' + job.shop_estimate.DISCOUNT)) + ')';
		job.shop_estimate.COSTPERH = '$' + job.shop_estimate.COSTPERH +  '/hr';
		if (discount_type !== null) {
			job.shop_estimate.COSTPERH += ' (';
			if (discount_type === 'Disc.') {
				job.shop_estimate.COSTPERH += (1 - job.shop_estimate.DISCOUNT) + '% PI ';
			}
			job.shop_estimate.COSTPERH += discount_type + ')';
		}
	}
	
	canHaveLaborMaterial(shopId) {
		// if we don't know the shop yet, it is ok
		if (!this.isNumeric(shopId)) return true;
		
		// if the shop is known, it can't be Facilities or EH&S
		return (![5,6].includes(+shopId));
	}
		
	canClickTabItem(tab) {
		// prevent user from leaving a tab if an editor is open
		if (this.state.activeTab === 'Description' && this.state.editorsOpen.includes('shop_job_rch')) {
			this.showAlert('Editor Open', 'Please close the speedtype editor before leaving the Description tab.');
			return false;
		} else if (this.state.activeTab === 'Labor' && this.state.editorsOpen.includes('shop_job_labor')) {
			this.showAlert('Editor Open', 'Please close the labor editor before leaving the Labor tab.');
			return false;
		} else if (this.state.activeTab === 'Material' && this.state.editorsOpen.includes('shop_job_material')) {
			this.showAlert('Editor Open', 'Please close the material editor before leaving the Material tab.');
			return false;
		} else if (this.state.activeTab === 'Scope_Docs' && this.state.editorsOpen.includes('job_doc')) {
			this.showAlert('Editor Open', 'Please close the file editor before leaving the Scope/Docs tab.');
			return false;
		} else if (this.state.activeTab === 'Status' && this.state.editorsOpen.includes('job_comment')) {
			this.showAlert('Editor Open', 'Please close the status editor before leaving the Status tab.');
			return false;
		}
			
		return true;
	}
	
	onClickTabItem(tab) {
		if (tab === 'Scope/Docs') tab = 'Scope_Docs'
		this.props.navigate('/Jobtrack/Jobs/' + (this.props.params.jobId || 'new') + '/' + tab);
	}
	
	copyLaborEditColumns() {
		var newLaborEditColumns = this.copyColumns(laborEditColumns);
		// restrict employee options by shop ID
		if (this.isNumeric(this.getByAccessor(this.state || {}, 'job.shop_job.SHOP_ID'))) {
			var empIdx = this.findColumnByAccessor(newLaborEditColumns, 'EMPLOYEE_ID');
			newLaborEditColumns[empIdx].options.search = { Attribute: 'SHOP_ID', Operator: '=', LongValue: this.state.job.shop_job.SHOP_ID };
		}
		return newLaborEditColumns;
	}

	onEdit(accessor, editorIsOpen, idx) {
		var colidx;
		
		// adjust list of open editors in new state
		var newState = {
			editorsOpen: this.setEditorStatus(accessor, editorIsOpen),
			renderKey: this.state.renderKey + 1
		};
		
		if (editorIsOpen && accessor === 'shop_job_labor') {
			// adjust columns to state of record
			var sjl = (idx >= 0) ? this.state.job.shop_job_labor[idx] : emptyLabor;
			var newLaborEditCols = this.copyLaborEditColumns();
			colidx = {
				jobDate: this.findColumnByAccessor(newLaborEditCols, 'SORT_DATE'),
				billStatus: this.findColumnByAccessor(newLaborEditCols, 'BILL_STATUS'),
				readyToBill: this.findColumnByAccessor(newLaborEditCols, 'READY_TO_BILL'),
				laborTime: this.findColumnByAccessor(newLaborEditCols, 'LABOR_TIME'),
				empId: this.findColumnByAccessor(newLaborEditCols, 'EMPLOYEE_ID'),
			};

			// if labor has been transferred or billed
			if (!this.isEmpty(sjl.BILL_STATUS) && (sjl.BILL_STATUS === 'Transferred' || sjl.BILL_STATUS.startsWith('Billed '))) {
				// job date, labor time, employee ID are not editable
				newLaborEditCols[colidx.jobDate].editable = false;
				newLaborEditCols[colidx.laborTime].editable = false;
				newLaborEditCols[colidx.empId].editable = false;
				
				// ready to bill is not visible
				newLaborEditCols.splice(colidx.readyToBill, 1);
			} else {
				// bill status is not visible
				newLaborEditCols.splice(colidx.billStatus, 1);
			}
			
			newState.laborEditColumns = newLaborEditCols;
		} else if (editorIsOpen && accessor === 'shop_job_material') {
			var sjm = (idx >= 0) ? this.state.job.shop_job_material[idx] : emptyMaterial;
			var newMaterialEditCols = this.copyColumns(materialEditColumns);
			colidx = {
				jobDate: this.findColumnByAccessor(newMaterialEditCols, 'SORT_DATE'),
				billStatus: this.findColumnByAccessor(newMaterialEditCols, 'BILL_STATUS'),
				readyToBill: this.findColumnByAccessor(newMaterialEditCols, 'READY_TO_BILL')
			};
			
			// if material has been transferred or billed
			if (!this.isEmpty(sjm.BILL_STATUS) && (sjm.BILL_STATUS === 'Transferred' || sjm.BILL_STATUS.startsWith('Billed '))) {
				// job date is not editable
				newMaterialEditCols[colidx.jobDate].editable = false;
				
				// ready to bill is not visible
				newMaterialEditCols.splice(colidx.readyToBill, 1);
			} else {
				// bill status is not visible
				newMaterialEditCols.splice(colidx.billStatus, 1);
			}
			
			newState.materialEditColumns = newMaterialEditCols;
		}
		this.mergeState(newState);
	}
	
	setEditorStatus(accessor, editorIsOpen) {
		var editorsOpen = this.copyObject(this.state.editorsOpen);
		if (editorIsOpen) {
			// add to list if it isn't already present
			if (!editorsOpen.includes(accessor)) editorsOpen.push(accessor);
		} else {			
			// remove from list if it is present
			if (editorsOpen.includes(accessor)) editorsOpen.splice(editorsOpen.indexOf(accessor), 1);
		}
		return editorsOpen;
	}		

	onChange(accessor, value) {
		var i;
		var self = this;
		var job = this.copyObject(this.state.job);
		
		// if the shop is changing to Facilities or EH&S and there are labor or material entries
		if (this.mustRemoveLaborMaterial(accessor, value)) {
			// confirm with user that entries must be removed
			this.showOKCancel('Confirm Shop Change', 
				'Changing shop to Facility Management or EH&S requires removing all labor and material entries. Proceed?',
				(okClicked) => {
					if (okClicked) {
						// set new shop ID
						self.setByAccessor(job, accessor, value);
						// clear labor entries
						job.shop_job_labor = [];
						job.shop_job_material = [];
						self.mergeState({
							job: job,
							renderKey: this.state.renderKey + 1
						});
					}
				}
			);
		} else {
			this.setByAccessor(job, accessor, value);
			var newState = {
				job: job,
				renderKey: this.state.renderKey + 1
			};
			// if this accessor represents an EditTable
			if (['shop_job_rch','shop_job_labor','shop_job_material','job_doc','job_comment'].includes(accessor)) {
				// update editor status as well
				newState.editorsOpen = this.setEditorStatus(accessor, false);
				
				// if this is labor, recalculate labor costs and format job date
				if (accessor === 'shop_job_labor') {
					for (i = 0; i < value.length; i++) {
						this.calculateLaborCost(value[i]);
						value[i].JOB_DATE = this.dateToString(value[i].SORT_DATE);
					}
				} else if (accessor === 'shop_job_material') {
					for (i = 0; i < value.length; i++) {
						value[i].JOB_DATE = this.dateToString(value[i].SORT_DATE);
					}
				}
			} else if (Array.isArray(accessor) && accessor.includes('shop_job_pi.PI_ROLE')) {
				newState.speedtypeEditColumns = this.copyColumns(speedtypeEditColumns);
				var speedtypeColIdx = this.findColumnByAccessor(newState.speedtypeEditColumns, 'SPEEDTYPE');
				var piRoleID;
				for (i = 0; i < accessor.length; i++) {
					if (accessor[i] === 'shop_job_pi.PI_ROLE') {
						piRoleID = value[i];
						break;
					}
				}
				newState.speedtypeEditColumns[speedtypeColIdx].options.search = 
					{ Attribute: 'ROLE_ID', Operator: 'in', LongList: [0,piRoleID] };
			}
			this.mergeState(newState);
		}
	}
	
	onChangeMaterial(material, accessor, value) {
		// if part cost or qty has changed
		if (accessor === 'PART_COST' || accessor === 'PART_QTY') {
			// if both values are numeric
			if (this.isNumeric(material.PART_COST) && this.isNumeric(material.PART_QTY)) {
				// calculate total cost
				material.TOTAL_PART = this.round(+material.PART_COST * +material.PART_QTY, 2);
			} else {
				// total cost makes no sense
				material.TOTAL_PART = '';
			}
		}
	}
	
	calculateLaborCost(sjl) {
		if (this.isEmpty(sjl.BILL_STATUS) || !sjl.BILL_STATUS.startsWith('Billed ')) {
			var discount = sjl.SPONSORED_FLAG === 'Y' ? (1 - this.getNumeric(sjl.ALT_DISCOUNT, 0)) : (1 - this.getNumeric(sjl.DISCOUNT, 0));
			if (sjl.SUBSIDY_FLAG === 'N') {
				sjl.LABOR_COST = this.round(sjl.LABOR_TIME*sjl.COSTPERH*discount*sjl.PERCENT/100, 2);
			} else if (sjl.LABOR_FLAG === 'N') {
				sjl.LABOR_COST = this.round(sjl.LABOR_TIME*sjl.COSTPERH*sjl.PERCENT/100, 2);
			} else {
				sjl.LABOR_COST = 0;
			}
		}
	}
	
	mustRemoveLaborMaterial(accessor, value) {
		// if the shop ID is being set
		if (Array.isArray(accessor) && accessor.includes('shop_job.SHOP_ID')) {
			// find shop ID in value array
			var shopId = null;
			for (var i = 0; i < accessor.length; i++) {
				// if it is the shop ID 
				if (accessor[i] === 'shop_job.SHOP_ID') {
					// get shop ID and exit loop
					shopId = value[i];
					break;
				}
			}
			// if we found the shop ID and it is being set to Facility Management (5) or EH&S (6)
			// and there are labor or material entries attached to the job
			if (this.isNumeric(shopId) && [5,6].includes(+shopId) &&
				((Array.isArray(this.state.job.shop_job_labor) && this.state.job.shop_job_labor.length > 0) ||
				 (Array.isArray(this.state.job.shop_job_material) && this.state.job.shop_job_material.length > 0))) {
				// the entries must be removed
				return true;
			}
		}
		
		// no match, entries do not have to be removed
		return false;
	}
	
	sendEmail(email) {
		var self = this;
		
		if (email) {
			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Jobtrack/SendStatusUpdate',
				data: { 
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					email: email
				}
			}).done(function (data) {			
				if (data.Success) {
					self.setState({ showEmail: false, renderKey: self.state.renderKey + 1 });
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		} else {
			this.setState({ showEmail: false, renderKey: this.state.renderKey + 1 });
		}
	}
	
	onCanDeleteLine(line) {
		return(this.isEmpty(line.BILL_STATUS) ||
			(line.BILL_STATUS !== 'Transferred' && !line.BILL_STATUS.startsWith('Billed')));
	}
	
	onDuplicate() {
		var self = this;
		
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/DuplicateJob',
			overlay: true,
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				jobid: this.props.params.jobId
			}
		}).done(function (data) {
			if (data.Success) {
				self.props.navigate('/Jobtrack/Jobs/' + data.ID);
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	validatePI(validation, data) {
		if (validation === 'required') {
			// if both PI values are empty, validation fails
			return (!(this.isEmpty(this.getByAccessor(data, 'shop_job_pi.PI_ROLE')) && 
				this.isEmpty(this.getByAccessor(data, 'shop_job_pi.OTHER_PI'))));
		}
		
		// no other types of validation are required
		return true;
	}

	validateCustomer(validation, data) {
		if (validation === 'required') {
			// if both customer values are empty, validation fails
			return (!(this.isEmpty(this.getByAccessor(data, 'shop_job_pi.CUSTOMER_ID')) &&
				this.isEmpty(this.getByAccessor(data, 'shop_job_pi.OTHER_CUST'))));
		}

		// no other types of validation are required
		return true;
	}	
	
	validateJob(job) {
		var validation = null;
		
		// if job is not being deleted
		if (this.getNumeric(job.shop_job.STATUS_ID, 0) !== 10) {
			
			// validate data
			validation = this.validate([...piColumns, ...custColumns, ...descColumns], job);
			
			// ensure speedtypes add up to 100%
			var totalpct = 0;
			for (var i = 0; i < job.shop_job_rch.length; i++) {
				if (!this.isEmpty(job.shop_job_rch[i].SPEEDTYPE) && this.isNumeric(job.shop_job_rch[i].PERCENT)) {
					totalpct += +job.shop_job_rch[i].PERCENT;
				}
			}
			if (totalpct !== 100) {
				validation = this.join('; ', validation, 'Speedtypes must add up to 100% (currently ' + totalpct + '%)');
			}
		}
		
		return validation;
	}

	onSubmit(event) {
		var self = this;
		var i;
		
		// prevent user from saving if an editor is open
		if (this.state.activeTab === 'Description' && this.state.editorsOpen.includes('shop_job_rch')) {
			this.showAlert('Editor Open', 'Please close the speedtype editor before saving.');
		} else if (this.state.activeTab === 'Labor' && this.state.editorsOpen.includes('shop_job_labor')) {
			this.showAlert('Editor Open', 'Please close the labor editor before saving.');
		} else if (this.state.activeTab === 'Material' && this.state.editorsOpen.includes('shop_job_material')) {
			this.showAlert('Editor Open', 'Please close the material editor before saving.');
		} else if (this.state.activeTab === 'Scope_Docs' && this.state.editorsOpen.includes('job_doc')) {
			this.showAlert('Editor Open', 'Please close the file editor before saving.');
		} else if (this.state.activeTab === 'Status' && this.state.editorsOpen.includes('job_comment')) {
			this.showAlert('Editor Open', 'Please close the status editor before saving.');
		} else {
			var job = this.copyObject(this.state.job);
			var validation = this.validateJob(job);
			
			// if errors were returned
			if (!this.isEmpty(validation)) {
				this.showAlert('Data Validation', validation);
			} else {
				// perform data conversions
				this.js2mvc(job, piColumns);
				this.js2mvc(job, custColumns);
				
				// encode scope and notes so server will accept them
				job.job_scope.JOB_SCOPE = encode(job.job_scope.JOB_SCOPE);
				job.job_scope.JOB_NOTES = encode(job.job_scope.JOB_NOTES);

				// encode job comments so server will accept them
				// also translate Y/N to 2/1
				for (i = 0; i < job.job_comment.length; i++) {
					job.job_comment[i].COMMENT_TEXT = encode(job.job_comment[i].COMMENT_TEXT);
					job.job_comment[i].COMMENT_STATUS = job.job_comment[i].COMMENT_STATUS === 'Y' ? 2 : 1;
				}
				
				// for each document
				for (i = 0; i < job.job_doc.length; i++) {
					// if there is a create date
					if (!this.isEmpty(job.job_doc[i].DATE_CREATED)) {
						// make sure it is formatted to send back
						job.job_doc[i].DATE_CREATED = this.dateTimeToMVC(this.getDate(job.job_doc[i].DATE_CREATED));
					}
				}
				
				// copy dates for job labor
				for (i = 0; i < job.shop_job_labor.length; i++) {
					job.shop_job_labor[i].JOB_DATE = job.shop_job_labor[i].SORT_DATE;
				}
				
				// copy dates for job material
				for (i = 0; i < job.shop_job_material.length; i++) {
					job.shop_job_material[i].JOB_DATE = job.shop_job_material[i].SORT_DATE;
				}

				// Create an object of formData
				const formData = new FormData();

				// add the token to the formData
				formData.append('__RequestVerificationToken', this.props.user.antiForgeryToken);
				
				// for each file uploaded to the document table
				var newFileIdx = 0;
				var formFileIdx = 0;
				for (i = 0; i < this.state.job.job_doc.length; i++) {
					// if there is a file
					if (this.state.job.job_doc[i].JOB_FILE && this.state.job.job_doc[i].JOB_FILE.name) {
						// if this is a new document record
						if (!this.isNumeric(this.state.job.job_doc[i].DOCU_ID)) {
							// make up a unique ID
							job.job_doc[i].DOCU_ID = 'new_' + newFileIdx++;
						}
						
						// add the file information
						formData.append('files[' + (formFileIdx++) + ']', this.state.job.job_doc[i].JOB_FILE, job.job_doc[i].DOCU_ID);
					}
				}			

				// add the job to the formData
				var nvpairs = this.createHiddenFormData({ job: job });
				for (i = 0; i < nvpairs.length; i++) {
					formData.append(nvpairs[i].name, nvpairs[i].value);
				}

				this.ajax({
					type: 'POST',
					url: this.getConfig().host + '/Jobtrack/UpdateJob',
					data: formData,
					contentType: false,
					processData: false,
					overlay: true,
				}).done(function (data) {
					if (data.Success) {
						self.props.parent.showConfirmation(() => {
							var jobId = self.props.params.jobId || data.ID;
							var verb = self.props.params.jobId ? "updated" : "created";
							return (<>
								Job <Link to={'/Jobtrack/Jobs/' + jobId}>{jobId}</Link> {verb}.
							</>);
						});				
					} else {
						self.showAlert('Server Error', data.Message);
					}			
				}).fail(function (jqXHR, textStatus, errorThrown) {
					self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
				});
			}
		}
	}
	
	renderDocDownload(props) {
		if (this.isNumeric(props.value) && this.isEmpty(props.row.values.JOB_FILE)) {
			return(
				<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Download</Popover.Header></Popover>}>
					<form action={this.getConfig().host + '/Jobtrack/DownloadJobDoc'} method='POST'>
						<input type='hidden' name='__RequestVerificationToken' value={this.props.user.antiForgeryToken} />
						<input type='hidden' name='docid' value={props.value} />
						<input type='image' src={this.getConfig().host + '/Content/Icons/download.png'} alt="Download" />
					</form>
				</OverlayTrigger>
			);
		} else {
			return (
				<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Pending save</Popover.Header></Popover>}>
					<HourglassSplit />
				</OverlayTrigger>
			);
		}
	}
	
	renderDocImage(imgData) {
		if (!this.isEmpty(imgData)) {
			var style = {
				maxWidth: '300px',
				maxHeight: '300px',
			};
			var alt = 'job image';
			return (<img style={style} src={imgData} alt={alt} />);
		}
	}

	renderPartSearch(props) {
	  var self = this;
	  
	  return(
		<PartsModal parent={this} user={this.props.user} onClose={(accessor, value) => {
			if (accessor !== undefined && accessor !== null) {
				props.onChange(accessor, value);
			}
			self.mergeState({
				showPartSearch: false,
				partSearchProps: null
			});
		}} />
	  );
	}

	renderEmailModal() {
		var commaIdx = this.isEmpty(this.state.job.shop_job_pi.CUSTOMER_NAME) ? -1 :
			this.state.job.shop_job_pi.CUSTOMER_NAME.indexOf(',');
		var custFirstName = commaIdx === -1 ? this.state.job.shop_job_pi.CUSTOMER_NAME :
			this.state.job.shop_job_pi.CUSTOMER_NAME.substring(commaIdx + 1).trim();
		var comment = this.state.job.job_comment.length === 0 ? this.copyObject(emptyComment) : 
			this.copyObject(this.state.job.job_comment[this.state.job.job_comment.length - 1]);
		
		var email = {
			TO: this.state.job.shop_job_pi.EMAIL,
			REPLY_TO: this.props.user.email,
			CC: this.props.user.email,
			SUBJECT: (this.isEmpty(this.state.job.shop_job.SHOP_NAME) ? 'Job ' : 
				(this.state.job.shop_job.SHOP_NAME + ' job ')) + this.state.job.shop_job.JOB_ID + ' status',
			REFERENCE: this.state.job.shop_job.JOB_REF,
			SALUTATION: this.isEmpty(custFirstName) ? 'Dear Customer' : ('Dear ' + custFirstName),
			BODY: comment.COMMENT_TEXT,
			ENTERED: this.composeChangeInfo(comment.CREATED_BY, comment.DATE_CREATED),
			MODIFIED: this.composeChangeInfo(comment.MODIF_BY, comment.DATE_MODIF),
			SIGNATURE: this.props.user.name
		};

		return (
			<EmailModal parent={this} user={this.props.user} email={email} onClose={(email) => this.sendEmail(email)} />
		);
	}

	render() {	
	
		var exportLaborData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Labor for Job ' + this.state.job.shop_job.JOB_ID,
			columns: this.convertWidthsToExcel(laborTableColumns),
			data: this.state.job.shop_job_labor
		});
		
		var exportMaterialData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Material for Job ' + this.state.job.shop_job.JOB_ID,
			columns: this.convertWidthsToExcel(materialTableColumns),
			data: this.state.job.shop_job_material
		});
		
		var exportSummaryData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Summary for Job ' + this.state.job.shop_job.JOB_ID,
			columns: this.convertWidthsToExcel(summaryLineColumns),
			data: this.state.job.summary_lines
		});

		var jobPdfData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			jobid: this.state.job.shop_job.JOB_ID
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col sm={6}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
						  Job {this.props.params.jobId || '(new)'}&nbsp;&nbsp;
							{this.state.editable ? 
							  <UnlockFill style={{ cursor: 'pointer', marginTop: '-4px' }}
								onClick={() => this.mergeState({ editable: false })} /> : 
							  <LockFill style={{ cursor: 'pointer', marginTop: '-4px' }} 
								onClick={() => this.mergeState({ editable: true })} />}
						</div>
					  </Col>
					  <Col sm={6}>
						{this.props.params.jobId && <form class='float-end' action={this.getConfig().host + '/Jobtrack/JobPdf'} method='POST' target='_blank'>
							{jobPdfData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Print Job</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Print Job" />
							</OverlayTrigger>
						</form>}
					  </Col>
					</Row>
					<Row>
				      <Tabs activeTab={this.state.activeTab.replace('_', '/')} canClickTabItem={(tab) => this.canClickTabItem(tab)}
						  onClickTabItem={(tab) => this.onClickTabItem(tab)}>
						<div label='Description'>
						  <Container fluid>
							<Row>
						      <Col xs={4} style={{ paddingBottom: '10px' }}>
								<ChemEdit parent={this} user={this.props.user} columns={this.state.piColumns} data={this.state.job}
								  onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
								  labelColWidth={3} valueColWidth={9} editable={this.state.editable} />
							  </Col>
						      <Col xs={8} style={{ paddingBottom: '10px' }}>
								<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptySpeedtype} 
								  data={this.state.job.shop_job_rch} editable={this.state.editable} tableColumns={speedtypeTableColumns} 
								  editColumns={this.state.speedtypeEditColumns} tableName='Jobtrack_Job_ShopJobRch' 
								  onEdit={(editorIsOpen, idx) => this.onEdit('shop_job_rch', editorIsOpen, idx)}
								  onChange={(data, callback) => this.onChange('shop_job_rch', data)} />
						      </Col>
							</Row>
							<Row>
							  <Col style={{ paddingBottom: '10px' }}>
								<ChemEdit parent={this} user={this.props.user} columns={this.state.custColumns} data={this.state.job}
								  onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
								  editable={this.state.editable} />
							  </Col>
							</Row>
							<Row>
						      <Col xs={5} style={{ paddingBottom: '10px' }}>
								<ChemEdit parent={this} user={this.props.user} columns={nameColumns} data={this.state.job}
								  onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
								  labelColWidth={3} valueColWidth={9} editable={this.state.editable} />
							  </Col>
						      <Col xs={7} style={{ paddingBottom: '10px' }}>
							    Speedtype Action Changes
								<ChemTable parent={this} user={this.props.user} renderKey={this.state.renderKey}
								  data={this.state.job.rch_history} editable={false} columns={historyColumns} 
								  tableName='Jobtrack_Job_RchHistory' />
						      </Col>
							</Row>
							<Row>
							  <Col xs={12} style={{ paddingBottom: '10px' }}>
								<ChemEdit parent={this} user={this.props.user} columns={descColumns} data={this.state.job}
								  onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
								  editable={this.state.editable} />
							  </Col>
							</Row>
							<Row>
							  <Col style={{ paddingBottom: '10px' }}>
								<ChemEdit parent={this} user={this.props.user} columns={commentColumns} data={this.state.job}
								  onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
								  editable={this.state.editable} />
							  </Col>
							</Row>
						  </Container>
						</div>
						<div label='Estimate'>
						  <ChemEdit parent={this} user={this.props.user} columns={estimateColumns} data={this.state.job}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							editable={this.state.editable} />
						</div>
						<div label='Labor'>
						 {this.canHaveLaborMaterial(this.state.job.shop_job.SHOP_ID) ?
						  <Container fluid>
							<Row>
							  <Col>
								<form action={this.getConfig().host + '/Home/ExcelData'} method='POST'>
									{exportLaborData.map((excelFormField, index) => {
										return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
									})}
									<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
									  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
									</OverlayTrigger>
								</form>
							  </Col>
							</Row>
							<Row>
							  <Col>
								<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyLabor}
								  data={this.state.job.shop_job_labor} editable={this.state.editable} tableColumns={laborTableColumns} 
								  editColumns={this.state.laborEditColumns} tableName='Jobtrack_Job_ShopJobLabor' 
								  onEdit={(editorIsOpen, idx) => this.onEdit('shop_job_labor', editorIsOpen, idx)}
								  onChange={(data, callback) => this.onChange('shop_job_labor', data)}
								  onCanDelete={(row) => this.onCanDeleteLine(row)} />
							  </Col>
							</Row>
						  </Container> :
						  <span style={{ fontStyle: 'italic' }}>Labor entries cannot be added to {this.state.job.shop_job.SHOP_NAME} jobs.</span>
						 }
						</div>
						<div label='Material'>
						 {this.canHaveLaborMaterial(this.state.job.shop_job.SHOP_ID) ? <>
						  <Container fluid>
							<Row>
							  <Col>
								<form action={this.getConfig().host + '/Home/ExcelData'} method='POST'>
									{exportMaterialData.map((excelFormField, index) => {
										return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
									})}
									<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
									  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
									</OverlayTrigger>
								</form>
							  </Col>
							</Row>
							<Row>
							  <Col>
								<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyMaterial}
								  data={this.state.job.shop_job_material} editable={this.state.editable} tableColumns={materialTableColumns} 
								  editColumns={this.state.materialEditColumns} tableName='Jobtrack_Job_ShopJobMaterial' 
								  onEdit={(editorIsOpen, idx) => this.onEdit('shop_job_material', editorIsOpen, idx)}
								  onChange={(data, callback) => this.onChange('shop_job_material', data)}
								  onChangeInternal={(material, accessor, value) => this.onChangeMaterial(material, accessor, value)}
								  onCanDelete={(row) => this.onCanDeleteLine(row)} />
							  </Col>
							</Row>
						  </Container>
						  {this.state.showPartSearch && createPortal(this.renderPartSearch(this.state.partSearchProps), document.body)}</> :
						  <span style={{ fontStyle: 'italic' }}>Material entries cannot be added to {this.state.job.shop_job.SHOP_NAME} jobs.</span>
						 }
						</div>
						<div label='Schedule'>
						  <ChemEdit parent={this} user={this.props.user} columns={scheduleColumns} data={this.state.job}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							editable={this.state.editable} />
						</div>
						<div label='Scope/Docs'>
						  <ChemEdit parent={this} user={this.props.user} columns={scopeColumns} data={this.state.job}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							editable={this.state.editable} labelColWidth={2} valueColWidth={10} />
						  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyDoc}
							data={this.state.job.job_doc} editable={this.state.editable} tableColumns={docTableColumns} 
							editColumns={docEditColumns} tableName='Jobtrack_Job_Doc' 
							onEdit={(editorIsOpen, idx) => this.onEdit('job_doc', editorIsOpen, idx)}
							onChange={(data, callback) => this.onChange('job_doc', data)} />
						</div>
						<div label='Status'>
						  <Container fluid>
						    <Row style={{ marginBottom: '8px' }}>
							  <Col sm={11}>
								<div class='float-end'>Send job status to customer</div>
							  </Col>
							  <Col sm={1}>
								<Button style={{ marginTop: '-8px' }} id="partSearch" variant="warning" type="button"
								  onClick={() => this.mergeState({ showEmail: true })}><EnvelopeAt />
								</Button>
							  </Col>
							</Row>
							<Row>
							  <Col>
								<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyComment}
								  data={this.state.job.job_comment} editable={this.state.editable} tableColumns={commentTableColumns} 
								  editColumns={commentEditColumns} tableName='Jobtrack_Job_Comment' 
								  onEdit={(editorIsOpen, idx) => this.onEdit('job_comment', editorIsOpen, idx)}
								  onChange={(data, callback) => this.onChange('job_comment', data)}
								  labelColWidth={2} valueColWidth={10} />
							    {this.state.showEmail && createPortal(this.renderEmailModal(), document.body)}
							  </Col>
							</Row>
						  </Container>
						</div>
						<div label='Summary'>
						  <Container fluid>
						    <Row>
							  <Col>
								<ChemEdit parent={this} user={this.props.user} columns={summaryNameColumns} data={this.state.job}
								  renderKey={this.state.renderKey} editable={false} labelColWidth={2} valueColWidth={10} />
								<ChemEdit parent={this} user={this.props.user} columns={summaryColumns} data={this.state.job}
								  renderKey={this.state.renderKey} editable={false} />
							  </Col>
							</Row>
							<Row>
							  <Col>
							  	<form action={this.getConfig().host + '/Home/ExcelData'} method='POST'>
									{exportSummaryData.map((excelFormField, index) => {
										return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
									})}
									<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
									  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
									</OverlayTrigger>
								</form>
							  </Col>
							</Row>
						    <Row>
							  <Col>
								<ChemTable parent={this} user={this.props.user} renderKey={this.state.renderKey}
								  data={this.state.job.summary_lines} columns={summaryLineColumns} 
								  tableName='Jobtrack_Job_Summary' />
							  </Col>
							</Row>
						  </Container>
						</div>
					  </Tabs>
					</Row>
					<Row>
					  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
						{this.state.editable && <Button style={{ marginLeft: '10px' }} id="save" variant="warning" type="button" className="float-end"
							onClick={(event) => this.onSubmit(event)}>Save</Button>}
						{this.props.params.jobId && <Button id="duplicate" variant="warning" type="button" className="float-end"
							onClick={(event) => this.onDuplicate(event)}>Duplicate</Button>}
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const piColumns = [
	{ Header: 'PI', valueAccessor: 'shop_job_pi.PI_ROLE', accessor: 'shop_job_pi.OTHER_PI', type: 'dropdown', row: 0, col: 0, required: true,
		validate: (props) => props.parent.validatePI(props.validation, props.data),
		options: { value: 'ROLE_ID', label: 'PI_NAME', entity: 'RECHARGES.JOB_EDIT_PI_SELECT_VW', order: 'PI_NAME',
			search: { Operator: 'or', Children: [{ Attribute: 'ACTIVE_FLAG', Operator: '=', StringValue: 'Y' }]}}},
	{ Header: 'Project', accessor: 'shop_job.PROJECT_ID', type: 'select', row: 1, col: 0,
		options: { value: 'PROJECT_ID', label: 'PROJECT_LABEL', entity: 'RECHARGES.PROJECT_DROPDOWN_VW', order: 'PROJECT_ID desc' }}
];

const emptySpeedtype = {
	id: null,
	JOB_RCH_ID: null,
	JOB_PI_ID: null,
	SPEEDTYPE: null,
	PERCENT: null,
	GOOD_UNTIL: null,
	COMMENTS: null,
	DELETE_FLAG: null,
	CREATED_BY: null,
	DATE_CREATED: null,
	DATE_MODIF: null,
	MODIF_BY: null	
};

const speedtypeTableColumns = [
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 100 },
	{ Header: 'Percent', accessor: 'PERCENT', width: 60 },
	{ Header: 'Description', accessor: 'DESCRIPTION', width: 400 }
];

const speedtypeEditColumns = [
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', labelAccessor: ['SPEEDTYPE','PI_NAME','DESCRIPTION'], 
		type: 'multicolumn', allowEntry: true, row: 0, col: 0,
		options: { value: 'SPEEDTYPE', label: ['SPEEDTYPE','PI_NAME','DESCRIPTION'],
			entity: 'RECHARGES.JOB_SPEEDTYPE_PTO_VW', order: ['PTO_FIRST','PI_NAME','SPEEDTYPE'] }},
	{ Header: 'Percent', accessor: 'PERCENT', row: 0, col: 1 }
];

const custColumns = [
	{ Header: 'Customer', accessor: 'shop_job_pi.CUSTOMER_ID', labelAccessor: ['shop_job_pi.OTHER_CUST','shop_job_pi.CUST_EMAIL',
		'shop_job_pi.CUST_LOC','shop_job_pi.CUST_PHONE'], type: 'multicolumn', row: 0, col: 0, required: true,
		validate: (props) => props.parent.validateCustomer(props.validation, props.data),
		allowEntry: 'Use customer information as entered',
		options: { value: 'ROLE_ID', label: ['CUSTOMER_NAME','EMAIL','LOCATION','OFFICE_PHONE'], entity: 'RECHARGES.JOB_CUST_DROPDOWN_VW',
			order: 'CUSTOMER_NAME', search: {Operator: 'or', Children: [
			  { Attribute: 'ACTIVE_FLAG', Operator: '=', StringValue: 'Y' }]}}},
	{ Header: 'Email', accessor: 'shop_job_pi.CUST_EMAIL', row: 0, col: 1, editable: false },
	{ Header: 'Location', accessor: 'shop_job_pi.CUST_LOC', row: 0, col: 2, editable: false },
	{ Header: 'Phone', accessor: 'shop_job_pi.CUST_PHONE', row: 1, col: 0, editable: false },
	{ Header: 'Status', accessor: 'shop_job.STATUS_ID', type: 'select', row: 1, col: 1, required: true,
		options: { value: 'STATUS_ID', label: 'STATUS_NAME', entity: 'RECHARGES.JOB_STATUS', order: 'STATUS_NAME',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Shop', accessor: 'shop_job.SHOP_ID', labelAccessor: 'shop_job.SHOP_NAME', type: 'select', row: 1, col: 2, required: true,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.SHOPS',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}}
];

const nameColumns = [
	{ Header: 'Name', accessor: 'shop_job.JOB_REF', type: 'textarea', row: 0, col: 0, maxlength: 150, required: true }
];

const descColumns = [
	{ Header: 'Description', accessor: 'shop_job.JOB_DESC', type: 'textarea', row: 0, col: 0, maxlength: 500, labelColWidth: 2, valueColWidth: 10 }
];

const historyColumns = [
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 100 },
	{ Header: 'Created By', accessor: 'CREATED_BY', width: 125 },
	{ Header: 'Date Created', accessor: 'DATE_CREATED', width: 100 },
	{ Header: 'Modified By', accessor: 'MODIF_BY', width: 125 },
	{ Header: 'Date Modified', accessor: 'DATE_MODIF', width: 110 }
];

const commentColumns = [
	{ Header: 'Estimated Labor Hrs', accessor: 'shop_estimate.ESTIMATED_LABOR', row: 0, col: 0, editable: false },
	{ Header: 'Estimated Material Cost', accessor: 'shop_estimate.ESTIMATED_MAT', row: 0, col: 1, editable: false },
	{ Header: 'External Job #', accessor: 'shop_job.EXTERNAL_JOBNO', row: 0, col: 2 },
	{ Header: 'Internal Job Comments', accessor: 'shop_job.COMMENTS', type: 'textarea', row: 1, col: 0,
		subscript: '500 Characters Max' },
	{ Header: 'Created', accessor: 'shop_job.CREATED', row: 1, col: 1, editable: false },
	{ Header: 'Modified', accessor: 'shop_job.MODIFIED', row: 1, col: 2, editable: false }
];

const estimateColumns = [
	{ Header: 'College Hrs', accessor: 'shop_estimate.ESTIMATED_LABOR', row: 0, col: 0 },
	{ Header: 'Current Hourly Cost', accessor: 'shop_estimate.COSTPERH', row: 0, col: 1 },
	{ Header: 'PI Estimated Labor Cost', accessor: 'shop_estimate.PI_EST_LABOR', row: 0, col: 2 },
	{ Header: 'Material Cost', accessor: 'shop_estimate.ESTIMATED_MAT', row: 1, col: 0 },
	{ Header: 'Customer Budget', accessor: 'shop_estimate.TOTAL_ESTIMATE', row: 1, col: 1 },
	{ Header: 'Estimate Good Until', accessor: 'shop_estimate.ESTIMATE_DATE', type: 'date', row: 1, col: 2 },
	{ Header: 'Comments', accessor: 'shop_estimate.COMMENTS', type: 'textarea', row: 2, col: 0, colwidth: 12, labelColWidth: 2, valueColWidth: 10 }
];

const emptyLabor = {
	id: null,
	LABOR_ID: null,
	JOB_DATE: null,
	BILL_STATUS: 'Not Transferred',
	READY_TO_BILL: 'Y',
	LABOR_TIME: 0,
	EMPLOYEE_ID: null,
	EMP_NAME: '',
	COMMENTS: '',
	ENTERED: ''
};

const laborTableColumns = [
	{ Header: 'Date', accessor: 'JOB_DATE' },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE' },
	{ Header: 'Percentage', accessor: 'PERCENT' },
	{ Header: 'Rate', accessor: 'COSTPERH' },
	{ Header: 'Discount', accessor: 'CURRENT_DISCOUNT' },
	{ Header: 'Labor Time', accessor: 'LABOR_TIME' },
	{ Header: 'Labor Cost', accessor: 'LABOR_COST' },
	{ Header: 'Employee', accessor: 'EMP_NAME' },
	{ Header: 'Billing Status', accessor: 'BILL_STATUS' }
];

const laborEditColumns = [
	{ Header: 'Service Date', accessor: 'SORT_DATE', type: 'date', row: 0, col: 0 },
	{ Header: 'Billing Status', accessor: 'BILL_STATUS', row: 0, col: 1, editable: false },
	{ Header: 'Ready To Bill', accessor: 'READY_TO_BILL', type: 'select', row: 0, col: 1, 
		options: [{ value: null, label: 'No' },{ value: 'Y', label: 'Yes' }]},
	{ Header: 'Labor Hrs', accessor: 'LABOR_TIME', row: 1, col: 0 },
	{ Header: 'Employee', accessor: 'EMPLOYEE_ID', labelAccessor: 'EMP_NAME', type: 'select', row: 1, col: 1,
		options: { value: 'EMP_ID', label: 'EMP_NAME', entity: 'RECHARGES.JOB_EMP_SELECT_VW', order: 'EMP_NAME' }},
	{ Header: 'Labor Comment', accessor: 'COMMENTS', type: 'textarea', row: 2, col: 0, colwidth: 12 },
	{ Header: 'Line ID', accessor: 'LABOR_ID', row: 3, col: 0, editable: false },
	{ Header: 'Entered By', accessor: 'ENTERED', row: 3, col: 1, editable: false }
];

const emptyMaterial = {
	id: null,
	MATERIAL_ID: null,
	JOB_DATE: null,
	BILL_STATUS: 'Not Transferred',
	READY_TO_BILL: null,
	PART_NAME: '',
	PART_QTY: 0,
	TOTAL_PART: 0,
	COMMENTS: '',
	ENTERED: ''
};

const materialTableColumns = [
	{ Header: 'Date', accessor: 'JOB_DATE' },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE' },
	{ Header: 'Percentage', accessor: 'PERCENT' },
	{ Header: 'Part Name', accessor: 'PART_NAME' },
	{ Header: 'Unit Cost', accessor: 'PART_COST' },
	{ Header: 'Qty', accessor: 'PART_QTY' },
	{ Header: 'Material Cost', accessor: 'TOTAL_PART' },
	{ Header: 'Status', accessor: 'BILL_STATUS' },
	{ Header: 'Comments', accessor: 'COMMENTS' }
];

const materialEditColumns = [
	{ Header: 'Service Date', accessor: 'SORT_DATE', type: 'date', row: 0, col: 0 },
	{ Header: 'Billing Status', accessor: 'BILL_STATUS', row: 0, col: 1, editable: false },
	{ Header: 'Ready To Bill', accessor: 'READY_TO_BILL', type: 'select', row: 0, col: 1, 
		options: [{ value: null, label: 'No' },{ value: 'Y', label: 'Yes' }]},
	{ Header: 'Part Name', accessor: 'PART_NAME', row: 1, col: 0 },
	{ Header: 'Search for Part', accessor: 'PART_NAME', row: 1, col: 1,
		Cell: props => <Button style={{ marginTop: '-8px' }} id="partSearch" variant="warning" type="button"
			onClick={() => props.parent.props.parent.mergeState({ 
				showPartSearch: true, 
				partSearchProps: {
					accessor: props.accessor,
					value: props.value,
					onChange: (accessor, value) => props.onChange(accessor, value)
				}})}><Search /></Button> },
	{ Header: 'Qty', accessor: 'PART_QTY', row: 2, col: 0 },
	{ Header: 'Unit Cost', accessor: 'PART_COST', row: 2, col: 1 },
	{ Header: 'Material Comment', accessor: 'COMMENTS', type: 'textarea', row: 3, col: 0 },
	{ Header: 'Total Cost', accessor: 'TOTAL_PART', row: 3, col: 1, editable: false },
	{ Header: 'Line ID', accessor: 'MATERIAL_ID', row: 4, col: 0, editable: false },
	{ Header: 'Entered By', accessor: 'ENTERED', row: 4, col: 1, editable: false }
];

const scheduleColumns = [
	{ Header: 'Job Start Date', accessor: 'shop_job.START_DATE', type: 'date', row: 0, col: 0 },
	{ Header: 'Job End Date', accessor: 'shop_job.END_DATE', type: 'date', row: 0, col: 1 }
];

const scopeColumns = [
	{ Header: 'Scope', accessor: 'job_scope.JOB_SCOPE', type: 'editor', row: 0, col: 0 },
	{ Header: 'Notes', accessor: 'job_scope.JOB_NOTES', type: 'editor', row: 1, col: 0 },
	{ Header: 'Comments', accessor: 'job_scope.COMMENTS', type: 'textarea', row: 2, col: 0 }
];

const emptyDoc = {
	id: null,
	DOCU_ID: null,
	JOB_ID: null,
	DOC_NAME: '',
	JOB_DOC: null,
	JOB_FILE: null,
	COMMENTS: null,
	UPDATED: null
};

const docTableColumns = [
	{ Header: '', accessor: 'JOB_FILE', show: false },
	{ Header: 'ID', accessor: 'DOCU_ID', width: 70,
		Cell: props => props.parent.props.parent.renderDocDownload(props) },
	{ Header: 'Name', accessor: 'DOC_NAME', width: 125 },
	{ Header: 'Image', accessor: 'JOB_DOC', width: 306,
		Cell: props => props.parent.props.parent.renderDocImage(props.value) },
	{ Header: 'Type', accessor: 'TYPE', width: 50 },
	{ Header: 'Description', accessor: 'DOC_DESC', width: 400 },
	{ Header: 'Updated', accessor: 'UPDATED', width: 200 }
];

const docEditColumns = [
	{ Header: 'Name', accessor: 'DOC_NAME', row: 0, col: 0 },
	{ Header: 'New File', accessor: 'JOB_FILE', type: 'file', row: 0, col: 1 },
	{ Header: 'Updated', accessor: 'UPDATED', row: 0, col: 2, editable: false },
	{ Header: 'Description', accessor: 'DOC_DESC', type: 'textarea', row: 1, col: 0, colwidth: 12 }
];

const emptyComment = {
	id: null,
	COMMENT_ID: '(new)',
	JOB_ID: null,
	COMMENT_TEXT: '',
	COMMENT_STATUS: null,
	COMMENTS: '',
	CREATED_BY: '',
	DATE_CREATED: null,
	MODIF_BY: '',
	DATE_MODIF: null,
	DELETE_FLAG: null
};

const commentTableColumns = [
	{ Header: 'ID', accessor: 'COMMENT_ID', width: 60 },
	{ Header: 'Comment', accessor: 'COMMENT_TEXT', width: 400 },
	{ Header: 'Entered', accessor: 'ENTERED', width: 200 },
	{ Header: 'Status', accessor: 'COMMENT_STATUS', width: 100,
		Cell: props => <>{props.value === 'Y' ? 'Published' : 'Not Published'}</> },
	{ Header: 'Updated', accessor: 'UPDATED', width: 200 }
];

const commentEditColumns = [
	{ Header: 'Comment', accessor: 'COMMENT_TEXT', type: 'editor', row: 0, col: 0, colwidth: 10 },
	{ Header: '', accessor: 'COMMENT_STATUS', type: 'checkbox', label: 'Publish', row: 0, col: 1, colwidth: 2 }
];

const summaryNameColumns = [
	{ Header: 'Name / Description', accessor: 'summary.JOB_REF' }
];

const summaryColumns = [
	{ Header: 'Current Speedtype(s)', accessor: 'summary.RCH', row: 0, col: 0, fragment: true },
	{ Header: 'Current PI', accessor: 'summary.PI_NAME', row: 0, col: 1 },
	{ Header: 'Current Customer', accessor: 'summary.CUSTOMER_NAME', row: 0, col: 2 },
	{ Header: 'Total Labor (hrs*rate*disc. factor)', accessor: 'summary.LABOR', row: 1, col: 0, fragment: true },
	{ Header: 'Total Material', accessor: 'summary.MATERIAL', row: 1, col: 1, fragment: true },
	{ Header: 'Estimates', accessor: 'summary.ESTIMATES', row: 1, col: 2, fragment: true }
];

const summaryLineColumns = [
	{ Header: 'Date', accessor: 'JOB_DATE' },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE' },
	{ Header: 'Labor Hours', accessor: 'LABOR_TIME' },
	{ Header: 'Labor Cost', accessor: 'LABOR_COST' },
	{ Header: 'Material Name/Part', accessor: 'PART_NAME' },
	{ Header: 'Material Cost', accessor: 'PART_COST' },
	{ Header: 'Employee', accessor: 'EMPLOYEE' },
	{ Header: 'Billing Status', accessor: 'BILL_STATUS' }
];

export default withJobDefaultRoute(Job);
